import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css'
import './App.css';
import {Login} from "./Components/UserLogin/Login";
import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';              
import {AppLayout} from "./Components/Home/AppLayout";
import * as sessionManager from '../src/Services/UserSessionManager';

const AppToastContainer = () => <ToastContainer theme='colored' style={{height: 50}} autoClose={3000}
                                                hideProgressBar={true}/>

function App() {
    const [LoginStatus, setLoginstatus] = useState(false);
 
    const authorizeUser = (token: any) => {
        setLoginstatus(token)
    }

    useEffect(()=>{
        setLoginstatus(sessionManager.IsAlreadyLoggedin());
    },[]);

    if (!LoginStatus) {

        return (
            <div>

                <AppToastContainer/>
                <Login onLoginSuccess={authorizeUser}/>

            </div>
        );
    } else {
        return (<>
            <AppToastContainer/>
            <BrowserRouter>
                <AppLayout/>
            </BrowserRouter>
        </>);
    }
}

export default App;


